import { render, staticRenderFns } from "./SignaturePadModal.vue?vue&type=template&id=b945a3dc&scoped=true&"
import script from "./SignaturePadModal.vue?vue&type=script&lang=ts&"
export * from "./SignaturePadModal.vue?vue&type=script&lang=ts&"
import style0 from "./SignaturePadModal.vue?vue&type=style&index=0&id=b945a3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b945a3dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VContent})
